/**
 * Task DR: 欠款 (pay later / customer debt), 钱包 (wallet), 推荐计划 (referral program).
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["dr.debt","Owing","欠款"],
  ["dr.payLater","Pay later (owing)","欠款（稍后付）"],
  ["dr.owes","Owes {amount}","欠 {amount}"],
  ["dr.debtWarn","This customer already owes {amount} ({n} sale(s), oldest {days} days ago).","该顾客已有欠款 {amount}（{n} 笔，最早 {days} 天前）。"],
  ["dr.debtNeedsCustomer","Choose the customer first — a walk-in can't owe money.","请先选择顾客 — 散客不能欠款。"],
  ["dr.debtOff","Pay later is off (Settings → Checkout).","欠款未开启（设置 → 收银）。"],
  ["dr.debtHint","The owing part is not money received. The customer pays it back later (cash, card, transfer or wallet).","欠款部分不计入实收。顾客之后可用现金、刷卡、转账或钱包余额还款。"],
  ["dr.wallet","Wallet","钱包"],
  ["dr.walletBalance","Wallet balance","钱包余额"],
  ["dr.outstanding","Outstanding debt","未还欠款"],
  ["dr.settle","Pay back","还款"],
  ["dr.settleTitle","Pay back debt","欠款还款"],
  ["dr.settleAll","Pay all","全部还清"],
  ["dr.fromWallet","Pay from wallet","用余额还欠款"],
  ["dr.method.cash","Cash","现金"],
  ["dr.method.external_card","Card (terminal)","刷卡（终端）"],
  ["dr.method.bank_transfer","Bank transfer","银行转账"],
  ["dr.method.wallet","Wallet balance","钱包余额"],
  ["dr.amount","Amount","金额"],
  ["dr.reference","Reference / approval code","参考号 / 授权码"],
  ["dr.tendered","Cash received","收到现金"],
  ["dr.change","Change {amount}","找零 {amount}"],
  ["dr.writeOff","Write off","核销"],
  ["dr.writeOffReason","Reason for the write-off","核销原因"],
  ["dr.writeOffConfirm","The written-off amount will no longer be collected. Owner only.","核销后不再追收这笔欠款。仅限老板。"],
  ["dr.history","Debt history","欠款记录"],
  ["dr.kind.give","Owed on sale","消费欠款"],
  ["dr.kind.settle","Paid back","还款"],
  ["dr.kind.reduce","Refund / cancelled","退款 / 取消"],
  ["dr.kind.write_off","Written off","核销"],
  ["dr.status.open","Owing","未还清"],
  ["dr.status.settled","Settled","已还清"],
  ["dr.status.written_off","Written off","已核销"],
  ["dr.status.void","Cancelled","已取消"],
  ["dr.sale","Sale","销售单"],
  ["dr.days","{days} days","{days} 天"],
  ["dr.printReceipt","Print repayment receipt","打印还款收据"],
  ["dr.receiptTitle","Repayment receipt","还款收据"],
  ["dr.receiptLeft","Still owing","尚欠"],
  ["dr.noDebt","Nothing owing","无欠款"],
  ["dr.debts","Debts","欠款"],
  ["dr.debtsSub","Customers who still owe money. Tap a customer to see the sales and take a repayment.","仍有欠款的顾客。点开顾客查看明细并收取还款。"],
  ["dr.search","Search name or phone","搜索姓名或电话"],
  ["dr.sortAmount","By amount","按金额"],
  ["dr.sortAge","By age","按时长"],
  ["dr.sortName","By name","按姓名"],
  ["dr.totalOutstanding","Total outstanding","欠款总额"],
  ["dr.customersN","{n} customer(s)","{n} 位顾客"],
  ["dr.exportCsv","Export CSV","导出 CSV"],
  ["dr.aging","Aging","账龄"],
  ["dr.aging.0_30","0–30 days","0–30 天"],
  ["dr.aging.31_60","31–60 days","31–60 天"],
  ["dr.aging.61_90","61–90 days","61–90 天"],
  ["dr.aging.90_plus","Over 90 days","90 天以上"],
  ["dr.collected","Paid back","已收回"],
  ["dr.given","New debt","新增欠款"],
  ["dr.writtenOff","Written off","核销"],
  ["dr.last30","Last 30 days","最近 30 天"],
  ["dr.oldest","Oldest","最早"],
  ["dr.salesN","{n} sale(s)","{n} 笔"],
  ["dr.settings.title","Pay later (欠款)","欠款（稍后付）"],
  ["dr.settings.enabled","Allow customers to owe part of a sale","允许顾客欠款"],
  ["dr.settings.limit","Max debt per customer","每位顾客欠款上限"],
  ["dr.settings.noLimit","Empty = no limit","留空 = 不限"],
  ["dr.settings.roles","Who can give pay-later at checkout","可以给欠款的角色"],
  ["dr.settings.viewRoles","Who can see debts and take repayments","可以查看欠款和收还款的角色"],
  ["dr.role.owner","Owner","老板"],
  ["dr.role.manager","Manager","店长"],
  ["dr.role.cashier","Cashier","收银员"],
  ["dr.settings.hint","Debt is not money received: the sale counts when it is made, the money counts on the day it is paid back (drawer, daily close, cash flow).","欠款不是实收：销售在开单时计入，钱在实际还款那天计入（钱箱、日结、现金流）。"],
  ["dr.walletHint","Wallet = stored value (top-ups) + bonus / cashback. It is never used automatically to pay a debt.","钱包 = 储值本金 + 赠送 / 返现。不会自动用来还欠款。"],
  ["dr.ref.title","Referral program","推荐计划"],
  ["dr.ref.enabled","Turn on the referral program","开启推荐计划"],
  ["dr.ref.referrer","The referrer (existing customer) gets","推荐人（老顾客）获得"],
  ["dr.ref.referee","The new customer gets","新顾客获得"],
  ["dr.ref.add","Add reward","添加奖励"],
  ["dr.ref.remove","Remove","移除"],
  ["dr.ref.type.cashback","Cashback to wallet","返现到钱包"],
  ["dr.ref.type.voucher","Discount voucher","折扣券"],
  ["dr.ref.type.service","Free service","免费服务"],
  ["dr.ref.type.product","Free product","免费产品"],
  ["dr.ref.type.package","Package","套餐"],
  ["dr.ref.mode.fixed","Fixed amount","固定金额"],
  ["dr.ref.mode.percent","% of the new customer's spend","新顾客消费的 %"],
  ["dr.ref.mode.percentOff","% off","折扣 %"],
  ["dr.ref.value","Amount","金额"],
  ["dr.ref.percent","Percent","百分比"],
  ["dr.ref.cap","Cap (optional)","上限（选填）"],
  ["dr.ref.voucherMin","Min. spend to use (optional)","使用门槛（选填）"],
  ["dr.ref.trigger","When to reward","何时发放"],
  ["dr.ref.trigger.fully_paid","When the new customer's first sale is fully paid (a sale with debt: once the debt is settled)","新顾客首单全部付清后（有欠款则还清后）"],
  ["dr.ref.trigger.first_sale","On the new customer's first sale (even if part is owed)","新顾客首单完成即发放（即使有欠款）"],
  ["dr.ref.minSpend","Minimum qualifying spend","首单最低消费"],
  ["dr.ref.newOnly","Only for new customers (no earlier sale)","仅限新顾客（之前无消费）"],
  ["dr.ref.monthly","Max rewards per referrer per month","每位推荐人每月最多奖励次数"],
  ["dr.ref.validDays","Vouchers / free items valid for (days)","优惠券 / 赠品有效天数"],
  ["dr.ref.cashbackDays","Cashback expires after (days)","返现有效天数"],
  ["dr.ref.emptyNever","Empty = never","留空 = 永久"],
  ["dr.ref.emptyNoLimit","Empty = no limit","留空 = 不限"],
  ["dr.ref.saved","Saved","已保存"],
  ["dr.ref.report","Referral report","推荐报表"],
  ["dr.ref.referrals","Referrals","推荐人数"],
  ["dr.ref.converted","Bought","已消费"],
  ["dr.ref.waiting","Waiting","待完成"],
  ["dr.ref.cashbackCost","Cashback given","返现成本"],
  ["dr.ref.vouchers","Vouchers issued / used","优惠券 发出 / 已用"],
  ["dr.ref.top","Top referrers","推荐排行"],
  ["dr.ref.limited","Skipped (monthly limit)","超出每月上限"],
  ["dr.ref.code","Referral code","推荐码"],
  ["dr.ref.link","Referral link","推荐链接"],
  ["dr.ref.referredBy","Referred by","推荐人"],
  ["dr.ref.people","People referred","推荐的顾客"],
  ["dr.ref.rewards","Rewards earned","获得的奖励"],
  ["dr.ref.none","None yet","暂无"],
  ["dr.ref.whoReferred","Referred by (optional)","推荐人（选填）"],
  ["dr.ref.codeOrPhone","Referral code, scan QR or phone","推荐码 / 扫码 / 电话"],
  ["dr.ref.find","Find","查找"],
  ["dr.ref.found","Referrer: {name}","推荐人：{name}"],
  ["dr.ref.notFound","No customer with that code or phone","找不到该推荐码或电话的顾客"],
  ["dr.ref.setReferrer","Save referrer","保存推荐人"],
  ["dr.ref.askAtCheckout","New customer — who referred them?","新顾客 — 是谁推荐的？"],
  ["dr.ref.st.granted","Rewarded","已奖励"],
  ["dr.ref.st.waiting","Waiting","待完成"],
  ["dr.ref.st.none","Joined","已加入"],
  ["dr.ref.st.skipped","—","—"],
  ["dr.ref.st.pending","Waiting","待完成"],
  ["dr.ref.choose","Choose…","请选择…"],
  ["dr.ref.copy","Copy link","复制链接"],
  ["dr.ref.copied","Copied","已复制"],
  ["dr.tab.checkout","Checkout","收银"],
  ["dr.tab.marketing","Marketing","营销"],
  ["dr.nav.debts","Debts","欠款"],
  ["dr.pos.collect","Collect debt","收欠款"],
  ["dr.pos.toast","{name} owes {amount} ({n} sale(s))","{name} 有欠款 {amount}（{n} 笔）"],
  ["dr.pos.settled","Repaid {amount} · still owing {left}","已还款 {amount} · 剩余欠款 {left}"],
  ["w7.ev.referral_reward","Referral reward (to the referrer)","推荐奖励（发给推荐人）"],
  ["w7.ev.referral_welcome","Referral welcome reward (to the new customer)","新客推荐礼（发给新顾客）"],
] as const;

export type DrKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<DrKey, string>;

export const taskDR = { en: col(1), zh: col(2), ms: col(1) };
